
export default function popover() {
  const popovers = document.querySelectorAll("[data-popover]");
  const triggers = [];

  for (const popover of popovers) {
    if (popover.childElementCount !== 2) {
      throw new Error(`Popover: "${popover.dataset.popover}" must have exactly two children.`);
    }

    const popoverId = popover.dataset.popover;
    const popoverContentId = `${popover.dataset.popover}-content`;

    popover.firstElementChild.setAttribute("id", popoverId);
    popover.firstElementChild.setAttribute("aria-expanded", false);
    popover.firstElementChild.setAttribute("aria-controls", popoverContentId);

    popover.lastElementChild.setAttribute("role", "region");
    popover.lastElementChild.setAttribute("aria-hidden", true);
    popover.lastElementChild.setAttribute("id", popoverContentId);
    popover.lastElementChild.setAttribute("aria-labelledby", popoverId);
    popover.lastElementChild.setAttribute("aria-controls", `${popover.dataset.popover}-content`);

    triggers.push(popover.firstElementChild);
  }

  let activePopover = null;

  document.addEventListener("click", event => {
    if (triggers.includes(event.target)) {
      const popover = event.target;
      const popoverContent = popover.nextElementSibling;

      // HIDE.
      if (popover.getAttribute("aria-expanded") === "true") {
        popover.setAttribute("aria-expanded", false);
        popoverContent.setAttribute("aria-hidden", true);
      }

      // SHOW.
      else {
        popover.setAttribute("aria-expanded", true);
        popoverContent.setAttribute("aria-hidden", false);
        activePopover = popover;
      }
    }
    else if (activePopover) {
      activePopover.setAttribute("aria-expanded", false);
      activePopover.nextElementSibling.setAttribute("aria-hidden", true);
      activePopover.focus();
      activePopover = null;
    }
  });
}
